import React from 'react'
import {
  DashboardOutlined,
  AppstoreOutlined,
  TagOutlined,
  ScanOutlined,
  OrderedListOutlined,
  ContactsOutlined,
  AccountBookOutlined,
  CarryOutOutlined,
  ShoppingCartOutlined,
  TeamOutlined,
  SettingOutlined,
  CameraOutlined,
  StarOutlined,
  ScheduleOutlined,
  BarChartOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'
import { ROUTE_PATHS } from '../../routes/constants'

export interface MenuItem {
  key: string
  icon?: React.ReactNode
  label: string
  path?: string
  badge?: number
  group?: string
  description?: string
}

export const getAllMenuItems = (): MenuItem[] => [
  {
    key: 'dashboard',
    icon: <DashboardOutlined style={{ fontSize: '18px' }} />,
    label: 'Dashboard',
    path: ROUTE_PATHS.DASHBOARD,
    group: 'main',
    description: 'Overview and insights',
  },
  {
    key: 'products',
    icon: <AppstoreOutlined style={{ fontSize: '18px' }} />,
    label: 'Products',
    path: ROUTE_PATHS.PRODUCTS,
    group: 'commerce',
    description: 'Manage your product catalog',
  },
  // {
  //   key: 'services',
  //   icon: <ShoppingOutlined style={{ fontSize: '18px' }} />,
  //   label: 'Services',
  //   path: '/services', // Placeholder path, update when services route is added
  //   group: 'commerce',
  //   description: 'Manage your services',
  // },
  {
    key: 'category',
    icon: <TagOutlined style={{ fontSize: '18px' }} />,
    label: 'Categories',
    path: ROUTE_PATHS.CATEGORIES,
    group: 'commerce',
    description: 'Organize products into categories',
  },
  {
    key: 'inventory',
    icon: <ScanOutlined style={{ fontSize: '18px' }} />,
    label: 'Inventory',
    path: ROUTE_PATHS.INVENTORY,
    group: 'commerce',
    description: 'Track stock and inventory',
  },
  {
    key: 'orders',
    icon: <OrderedListOutlined style={{ fontSize: '18px' }} />,
    label: 'Orders',
    path: ROUTE_PATHS.ORDERS,
    group: 'sales',
    description: 'Manage customer orders',
  },
  {
    key: 'campaigns',
    icon: <WhatsAppOutlined style={{ fontSize: '18px' }} />,
    label: 'Campaigns',
    path: ROUTE_PATHS.CAMPAIGN_TEMPLATES,
    group: 'sales',
    description: 'Manage marketing campaigns',
  },
  {
    key: 'customers',
    icon: <ContactsOutlined style={{ fontSize: '18px' }} />,
    label: 'Customers',
    path: ROUTE_PATHS.CUSTOMERS,
    group: 'sales',
    description: 'Customer management',
  },
  {
    key: 'payments',
    icon: <AccountBookOutlined style={{ fontSize: '18px' }} />,
    label: 'Payments',
    path: ROUTE_PATHS.PAYMENTS,
    group: 'sales',
    description: 'Payment processing and history',
  },
  {
    key: 'delivery',
    icon: <CarryOutOutlined style={{ fontSize: '18px' }} />,
    label: 'Delivery',
    path: ROUTE_PATHS.DELIVERY,
    group: 'sales',
    description: 'Delivery management',
  },

  {
    key: 'reports',
    icon: <BarChartOutlined style={{ fontSize: '18px' }} />,
    label: 'Reports',
    path: ROUTE_PATHS.REPORTS,
    group: 'analytics',
    description: 'Sales and performance reports',
  },

  {
    key: 'teams',
    icon: <TeamOutlined style={{ fontSize: '18px' }} />,
    label: 'Teams',
    path: ROUTE_PATHS.TEAMS,
    group: 'management',
    description: 'Manage team members',
  },
  {
    key: 'settings',
    icon: <SettingOutlined style={{ fontSize: '18px' }} />,
    label: 'Settings',
    path: ROUTE_PATHS.SETTINGS,
    group: 'management',
    description: 'Configure store settings',
  },
  {
    key: 'media',
    icon: <CameraOutlined style={{ fontSize: '18px' }} />,
    label: 'Media',
    path: ROUTE_PATHS.MEDIA,
    group: 'management',
    description: 'Manage media files',
  },
  {
    key: 'reviews',
    icon: <StarOutlined style={{ fontSize: '18px' }} />,
    label: 'Reviews',
    path: ROUTE_PATHS.STORE_REVIEWS,
    group: 'management',
    description: 'Customer feedback and reviews',
  },

  {
    key: 'master_data',
    icon: <ScheduleOutlined style={{ fontSize: '18px' }} />,
    label: 'Master Data',
    path: ROUTE_PATHS.MASTER_DATA,
    group: 'master_data',
    description: 'Product templates and master data',
  },
]

export const getModuleMenuItems = (modules: string[] | undefined, role: string): MenuItem[] => {
  const allMenuItems = getAllMenuItems()

  // If super_admin, show all menu items
  if (role === 'super_admin') {
    return allMenuItems
  }

  // If no modules assigned, show only dashboard
  if (!modules || modules.length === 0) {
    return allMenuItems.filter(item => item.key === 'dashboard')
  }

  // Filter items based on assigned modules - now all items are flat, no children
  const filteredItems = allMenuItems.filter(item => modules.includes(item.key))

  return filteredItems
}
